<template>
  <div>
    <form role="form">
      <div class="row">
        <div class="col-md-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">My ABFT</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <!-- <div class="form-group"> -->
                    <!-- <label for="statut">Statut</label>
                    <select id="statut"
                            class="form-control"
                            name="newParticipation[sexe]"
                            v-model="getMember.MyABFT_active">
                      <option :value="1"> Activé</option>
                      <option :value="0"> Désactivé</option>
                    </select>
                  </div> -->
                  <div class="form-group">
                    <b-form-group label="Droits">
                      <div class="checkbox">
                        <label for="read">
                          <input id="read" name="newEntry[read]" type="checkbox"
                                 v-model="getMember.canScanQrCode">
                          Peut scanner les QRCode
                        </label>
                      </div>
                    </b-form-group>
                  </div>
                  <button class="btn btn-primary pull-right m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="saveStatut()">
                    Sauvegarder
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="statut">Code MyABFT pour lier le compte</label>
                    <input type="text" class="form-control" id="codeMyABFT" disabled v-model="getMember.codeMyABFT">
                  </div>
                  <button class="btn btn-primary pull-right m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="generateCodeMyABFT()">
                    Générer un nouveau code
                  </button>
                </div>
                <!-- <div class="col-md-12">
                  <div class="form-group">
                    <label for="statut">Mot de passe</label>
                  </div>
                  <button class="btn btn-default pull-right"
                          :disabled="disabledBtn"
                          @click.prevent="generateCourrierNewPassword()">
                    (OBSOLETE - PRESENT POUR DEBUG) Activer MyABFT et générer un nouveau mot de passe
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="box box-warning">
            <div class="box-header with-border">
              <h3 class="box-title">Gestion du grade Keup (Extranet)</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Grade actuel (extranet)</label>
                    <p class="form-control-static">
                      <strong>{{ currentGradeExtranetLabel }}</strong>
                    </p>
                  </div>
                  <div class="form-group">
                    <label for="newGradeKeup">Modifier le grade Keup</label>
                    <select id="newGradeKeup" class="form-control" v-model="selectedGradeKeup">
                      <option :value="null" disabled>-- Sélectionner un grade --</option>
                      <option v-for="grade in gradesKeup"
                              :key="grade.id"
                              :value="grade.id">
                        {{ grade.grade }}
                      </option>
                    </select>
                  </div>
                  <div v-if="selectedGradeKeup && currentGradeExtranet && selectedGradeKeup != currentGradeExtranet.id_grade" class="alert alert-warning">
                    <i class="fa fa-exclamation-triangle"></i>
                    Attention : vous allez modifier le grade de ce membre. Cette action est réservée aux corrections d'encodage.
                  </div>
                  <button class="btn btn-primary pull-right m-5"
                          :disabled="disabledBtnGrade || !selectedGradeKeup || (currentGradeExtranet && selectedGradeKeup == currentGradeExtranet.id_grade)"
                          @click.prevent="saveGradeKeup()">
                    Sauvegarder le grade
                  </button>
                </div>
              </div>

              <div class="row" v-if="getMember.grade_extranet && getMember.grade_extranet.length > 0" style="margin-top: 15px;">
                <div class="col-md-12">
                  <label>Historique des grades</label>
                  <table class="table table-bordered table-striped table-condensed">
                    <thead>
                      <tr>
                        <th>Grade</th>
                        <th>Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="entry in getMember.grade_extranet" :key="entry.id">
                        <td>{{ entry.grade ? entry.grade.grade : '-' }}</td>
                        <td>{{ formatDate(entry.created_at) }}</td>
                        <td>
                          <button class="btn btn-danger btn-xs"
                                  :disabled="disabledBtnGrade"
                                  @click.prevent="deleteGradeExtranet(entry.id)">
                            <i class="glyphicon glyphicon-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6" >
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Définir les accès pour un club</h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <div v-if="getClubSelected">
                    <div class="selection-label">
                                    <span class="selection-label_remove" role="presentation"
                                          @click="removeClubSelected()">×</span>
                      {{ getClubSelected.club }}
                    </div>
                  </div>

                  <searchclub ref="searchclub"
                              :limit="5"
                              :min-chars="2"
                  >
                  </searchclub>
                  <br>
                  <br>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <b-form-group label="Droits">
                      <div class="checkbox">
                        <label for="read">
                          <input id="read" name="newEntry[read]" type="checkbox"
                                 v-model="newEntry.read">
                          Droit en lecture
                        </label>
                      </div>
                      <div class="checkbox">
                        <label for="write">
                          <input id="write" name="newEntry[write]" type="checkbox"
                                 v-model="newEntry.write">
                          Droit en écriture
                        </label>
                      </div>
                      <div class="checkbox">
                        <label for="can_register_member">
                          <input id="can_register_member" name="newEntry[can_register_member]" type="checkbox"
                                 v-model="newEntry.can_register_member">
                          Peut enregistrer des membres en ligne (version bêta)
                        </label>
                      </div>
                    </b-form-group>
                  </div>
                  <button class="btn btn-primary pull-right m-5  "
                          :disabled="disabledBtnActive"
                          @click.prevent="addAccess()">
                    Ajouter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>


        
        <div class="col-md-12" v-if="getMember.my_a_b_f_t_member_club && getMember.my_a_b_f_t_member_club.length > 0">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Clubs avec accès ({{getMember.my_a_b_f_t_member_club.length}} accès définis)</h3>
            </div>
            <div class="box-body">
              <b-table
                id="tableListingAllUserMyABFT"
                responsive bordered striped hover
                :items="getMember.my_a_b_f_t_member_club"
                :fields="columns"
                :current-page="pagination_meta.current_page"
                :per-page="pagination_meta.per_page"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-compare="sortCompareAdvanced"
                :no-local-sorting="true"
                :no-sort-reset="true"
                :empty-text="'Aucun résultat'"
                :empty-filtered-text="'Aucun résultat'"
                :busy.sync="isBusy"
                foot-clone
                show-empty
              >
                <template slot="user.club" slot-scope="data">
                  <router-link
                    :to="{ name: 'Club', params: { club_id: data.item.club.id }}">
                    {{data.item.club.club }}
                  </router-link>
                </template>

                <template slot="read" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.read==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).read">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>
                </template>

                <template slot="write" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.write==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).write"
                            @change="getObjectEditable(data.item.id).write==1 ? getObjectEditable(data.item.id).read=1 : '' ">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>

                </template>
                <template slot="can_register_member" slot-scope="data">
                  <div v-if="!isEditing(data.item.id)">
                    {{data.item.can_register_member==1 ? 'OUI':'NON'}}
                  </div>
                  <div v-if="isEditing(data.item.id)">
                    <select v-model="getObjectEditable(data.item.id).can_register_member"
                            @change="getObjectEditable(data.item.id).can_register_member==1 ? getObjectEditable(data.item.id).write=1 : '' ">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>
                </template>

                <template slot="actions" slot-scope="data">
                  <button v-if="!isEditing(data.item.id)"
                          @click.prevent="editItem(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-pencil"></i>
                  </button>
                  <button v-if="!isEditing(data.item.id)"
                          @click.prevent="removeInscriptionClub(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-remove"></i>
                  </button>
                  <button v-if="isEditing(data.item.id)"
                          @click.prevent="validEditing(data.item.id)"
                          class="btn btn-primary padding2">
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button v-if="isEditing(data.item.id)"
                          @click.prevent="cancelEditing(data.item.id)"
                          class="btn btn-danger padding2">
                    <i class="glyphicon glyphicon-ban-circle"></i>
                  </button>
                </template>

              </b-table>
              <b-pagination size="md"
                            :total-rows="getMember.my_a_b_f_t_member_club.length"
                            v-model="pagination_meta.current_page"
                            :per-page="pagination_meta.per_page">
              </b-pagination>
            </div>
          </div>
        </div>

        <!-- Tableau des comptes utilisateurs qui ont accès au membre -->
        <div class="col-md-12" v-if="getMember.my_a_b_f_t_user && getMember.my_a_b_f_t_user.length > 0">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Comptes utilisateurs liés ({{getMember.my_a_b_f_t_user.length}} comptes)</h3>
            </div>
            <div class="box-body">
              <b-table
                id="tableListingAllUserAccounts"
                responsive bordered striped hover
                :items="getMember.my_a_b_f_t_user"
                :fields="userColumns"
                :sort-by.sync="userSortBy"
                :sort-desc.sync="userSortDesc"
                :sort-compare="sortCompareAdvanced"
                :no-local-sorting="true"
                :no-sort-reset="true"
                :empty-text="'Aucun compte utilisateur lié'"
                :empty-filtered-text="'Aucun compte utilisateur lié'"
                :busy.sync="isBusy"
                foot-clone
                show-empty
              >
                <template slot="user.name" slot-scope="data">
                  {{data.item.user.name}} {{data.item.user.surname}}
                </template>

                <template slot="user.email" slot-scope="data">
                  {{data.item.user.email}}
                </template>

                <template slot="linked_at" slot-scope="data">
                  {{formatDate(data.item.linked_at)}}
                </template>

                <template slot="allowed_to_consult_member" slot-scope="data">
                  <div v-if="!isEditingUser(data.item.id)">
                    {{data.item.allowed_to_consult_member == 1 ? 'OUI' : 'NON'}}
                  </div>
                  <div v-if="isEditingUser(data.item.id)">
                    <select v-model="getObjectEditableUser(data.item.id).allowed_to_consult_member">
                      <option value="1">OUI</option>
                      <option value="0">NON</option>
                    </select>
                  </div>
                </template>

                <template slot="actions" slot-scope="data">
                  <button v-if="!isEditingUser(data.item.id)"
                          @click.prevent="editItemUser(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-pencil"></i>
                  </button>
                  <button v-if="!isEditingUser(data.item.id)"
                          @click.prevent="removeInscriptionUser(data.item.id)"
                          class="btn btn-default padding2">
                    <i class="glyphicon glyphicon-remove"></i>
                  </button>
                  <button v-if="isEditingUser(data.item.id)"
                          @click.prevent="validEditingUser(data.item.id)"
                          class="btn btn-primary padding2">
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button v-if="isEditingUser(data.item.id)"
                          @click.prevent="cancelEditingUser(data.item.id)"
                          class="btn btn-danger padding2">
                    <i class="glyphicon glyphicon-ban-circle"></i>
                  </button>
                </template>

              </b-table>
            </div>
          </div>
        </div>

      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import {ErrorBag} from 'vee-validate';
  import Datepicker from 'vuejs-datepicker';

  var $ = require('jquery');
  var variables = require('../../../assets/js/variables')
  var _ = require('underscore')
  var moment = require('moment')
  var FileSaver = require('file-saver');

  export default {
    data() {
      return {
        loading: {},
        statutMyABFT: 0,
        disabledBtn: false,
        disabledBtnActive: false,
        disabledBtnGrade: false,
        selectedGradeKeup: null,
        sortBy: null,
        sortDesc: null,
        arrayEdits: [],
        arrayEditsUser: [],
        isBusy: false,
        newEntry: {},
        pagination_meta: {
          current_page: 1,
          from: 1,
          last_page: 1,
          path: "",
          per_page: 20,
          to: 1,
          total: 1
        },
        columns: [
          {
            label: 'Club',
            key: 'user.club',
            sortable: true,
          },
          {
            label: 'Accès en lecture',
            key: 'read',
            sortable: false,
          },
          {
            label: 'Accès en écriture',
            key: 'write',
            sortable: false,
          },
          {
            label: 'Peut inscrire des membres en ligne',
            key: 'can_register_member',
            sortable: false,
          },
          {
            label: 'Actions',
            key: 'actions',
            sortable: false,
          },
        ],
        userColumns: [
          {
            label: 'Nom',
            key: 'user.name',
            sortable: true,
          },
          {
            label: 'Email',
            key: 'user.email',
            sortable: true,
          },
          {
            label: 'Date de lien',
            key: 'linked_at',
            sortable: true,
          },
          {
            label: 'Autorisé à consulter le compte',
            key: 'allowed_to_consult_member',
            sortable: false,
          },
          {
            label: 'Actions',
            key: 'actions',
            sortable: false,
          },
        ],
        userSortBy: null,
        userSortDesc: null,
      }
    },
    computed: {
      ...mapGetters({
        getMember: 'getMember',
        getRoute: 'getRoute',
        getClubSelected: 'getClubSelected',
        getDiplomes: 'getDiplomes',
      }),
      currentGradeExtranet() {
        if (!this.getMember.grade_extranet || this.getMember.grade_extranet.length === 0) return null
        return this.getMember.grade_extranet[0]
      },
      currentGradeExtranetLabel() {
        if (!this.currentGradeExtranet || !this.currentGradeExtranet.grade) return 'Non défini'
        return this.currentGradeExtranet.grade.grade
      },
      gradesKeup() {
        if (!this.getDiplomes) return []
        return _.filter(this.getDiplomes, (d) => { return d.desc === 'keup' })
      },
    },
    mounted: function () {
      var these = this
      this.$nextTick(function () {
        these.resetNewEntry()
        if (these.getMember.grade_extranet && these.getMember.grade_extranet.length > 0) {
          these.selectedGradeKeup = these.getMember.grade_extranet[0].id_grade
        }
      })
    },
    created() {
      this.loadDiplomes()
    },
    watch: {},
    components: {},
    methods: {
      ...mapActions({
        majClubSelected: "majClubSelected",
        removeClubSelected: "removeClubSelected",
        setDiplomes: "setDiplomes",
        setMember: "setMember",
      }),
      reloadMember() {
        this.$http.get(this.getRoute('getInfosMember') + this.getMember.id)
          .then((response) => {
            this.setMember(response.body)
            if (response.body.grade_extranet && response.body.grade_extranet.length > 0) {
              this.selectedGradeKeup = response.body.grade_extranet[0].id_grade
            }
          })
      },

      loadDiplomes() {
        if (!this.getDiplomes) {
          this.$http.get(this.getRoute('getAllDiplomes')).then((response) => {
            this.setDiplomes(response.body)
          })
        }
      },
      deleteGradeExtranet(idGradeExtranet) {
        if (!confirm('Êtes-vous sûr de vouloir supprimer cet encodage de grade ?')) return
        this.disabledBtnGrade = true
        let self = this
        this.$http.post(this.getRoute('Secretariat.deleteGradeKeup'),
          {
            id_grade_myabft: idGradeExtranet,
          })
          .then((response) => {
            self.disabledBtnGrade = false
            self.$noty.success("Encodage de grade supprimé")
            self.reloadMember()
          }, (response) => {
            self.disabledBtnGrade = false
            self.$noty.error("Erreur lors de la suppression")
          })
      },
      saveGradeKeup() {
        this.disabledBtnGrade = true
        let self = this
        this.$http.post(this.getRoute('Secretariat.updateGradeKeup'),
          {
            id_membre: self.getMember.id,
            id_grade: self.selectedGradeKeup,
          })
          .then((response) => {
            self.disabledBtnGrade = false
            self.$noty.success("Grade Keup modifié avec succès")
            self.reloadMember()
          }, (response) => {
            self.disabledBtnGrade = false
            self.$noty.error("Erreur lors de la modification du grade Keup")
          })
      },
      generateCodeMyABFT() {
        this.isBusy = true
        this.disabledBtnActive = true
        let self = this;

        this.$http.post(this.getRoute('generateCodeMyABFT'),
                {
            id_member: self.getMember.id,
          })
          .then((response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            this.getMember.codeMyABFT = response.body.code
          }, (response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.error("Erreur dans la génération du code")
          });
      },
      addAccessToMyABFT() {
        this.isBusy = true
        this.disabledBtnActive = true
        let self = this;

        this.$http.post(this.getRoute('addMemberToNewUserForMyABFT'),
          {
            id_member: self.getMember.id,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.success("Ajout de l'accès effectué")
            self.getMember.my_a_b_f_t_user = response.body
          }, (response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.error("Ajout de l'accès échoué.")
          });
      },
      addAccess() {
        this.isBusy = true
        this.disabledBtnActive = true
        let self = this;

        this.$http.post(this.getRoute('addRightForClubForMember2025'),
          {
            id_club: self.getClubSelected.id,
            id_member: self.getMember.id,
            read: self.newEntry.read,
            write: self.newEntry.write,
            can_register_member: self.newEntry.can_register_member,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtnActive = false
            this.removeClubSelected()
            this.resetNewEntry()
            self.$noty.success("Ajout effectué")
            self.getMember.my_a_b_f_t_user = response.body
          }, (response) => {
            this.isBusy = false
            this.disabledBtnActive = false
            self.$noty.error("Ajout échoué. Club déjà présent dans la liste?")
          });
      },
      resetNewEntry: function () {
        this.newEntry = {
          club: {
            id: 0,
            club: ""
          },
          read: 1,
          write: 1,
          can_register_member: 1,
        }
      },
      sortCompareAdvanced: function (a, b, key) {
        if (typeof a[key] === 'number' && typeof b[key] === 'number') {
          // If both compared fields are native numbers
          return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
        } else {
          // Stringify the field data and use String.localeCompare
          return (this.flatten(a)[key]).toString().localeCompare((this.flatten(b)[key]).toString(), undefined, {
            numeric: true
          })
        }
      },

      removeInscriptionClub: function (idMyAbftUserClub) {
        this.isBusy = true
        let self = this;
        let item = _.find(this.getMember.my_a_b_f_t_member_club, function (item) {
          return item.id == idMyAbftUserClub;
        });
        this.$http.post(this.getRoute('removeRightForClub2025'),
          {
            id_club: item.club.id,
            id_member: self.getMember.id,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            self.getMember.my_a_b_f_t_member_club = response.body
            this.arrayEdits = _.reject(this.arrayEdits, function (item) {
              return item.id == idMyAbftUserClub;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });
      },
      validEditing: function (idMyAbftUserClub) {
        this.isBusy = true
        let self = this;
        let item = this.getObjectEditable(idMyAbftUserClub);
        this.$http.put(this.getRoute('updateRightForClub2025'),
          {
            id_club: item.club.id,
            id_member: self.getMember.id,
            read: item.read,
            write: item.write,
            can_register_member: +item.can_register_member,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            this.arrayEdits = _.reject(this.arrayEdits, function (item) {
              return item.id == idMyAbftUserClub;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });

      },
      getObjectEditable: function (id) {
        return _.find(this.arrayEdits, function (item) {
          return item.id == id;
        })
      },

      editItem: function (id) {
        let self = this
        let item = _.find(this.getMember.my_a_b_f_t_member_club, function (item) {
          return item.id == id;
        });
        let item2 = _.find(this.arrayEdits, function (item) {
          return item.id == id;
        });
        // debugger
        if (!item2)
          this.arrayEdits.push(item)
      },
      cancelEditing: function (id) {
        this.arrayEdits = _.reject(this.arrayEdits, function (item) {
          return item == id;
        });
      },
      isEditing: function (id) {
        let test = _.find(this.arrayEdits, function (item) {
          return item.id == id;
        })
        return test ? true : false
      },

      saveStatut() {
        this.disabledBtnActive = true
        this.$http.post(this.getRoute('saveStatutMyABFT'),
          {id_member: this.getMember.id, 
            // active: this.getMember.MyABFT_active, 
            canScanQrCode: this.getMember.canScanQrCode}
        )
          .then((response) => {
            this.$noty.success("Statut sauvegardé!")
            this.disabledBtnActive = false
          }, (response) => {
            this.$noty.error("Erreur dans la sauvegarde du statut")
            this.disabledBtnActive = false
          });
      },
      generateCourrierNewPassword() {
        this.disabledBtn = true
        this.$http.post(this.getRoute('generateCourrierNewPassword'),
          {typeCourrier: "generateCourrierNewPassword", id_member: this.getMember.id},
          {responseType: 'blob'})
          .then((response) => {
            var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
            FileSaver.saveAs(blob, this.getMember.id + "_password.pdf");
            this.disabledBtn = false
            this.getMember.MyABFT_active = 1
            return response.blob();
          }, (response) => {
            this.$noty.error("Erreur dans la génération du courrier")
            this.disabledBtn = false
          });
      },
      formatDate(date) {
        if (date) {
          return moment(date).format('DD/MM/YYYY HH:mm');
        }
        return '';
      },
      isEditingUser: function (id) {
        let test = _.find(this.arrayEditsUser , function (item) {
          return item.id == id;
        })
        return test ? true : false
      },
      getObjectEditableUser: function (id) {
        return _.find(this.arrayEditsUser, function (item) {
          return item.id == id;
        })
      },
      editItemUser: function (id) {
        let self = this
        let item = _.find(this.getMember.my_a_b_f_t_user, function (item) {
          return item.id == id;
        });
        let item2 = _.find(this.arrayEditsUser, function (item) {
          return item.id == id;
        });
        // debugger
        if (!item2)
          this.arrayEditsUser.push(item)
      },
      cancelEditingUser: function (id) {
        this.arrayEditsUser = _.reject(this.arrayEditsUser, function (item) {
          return item == id;
        });
      },
      validEditingUser: function (id) {
        this.isBusy = true
        let self = this;
        let item = this.getObjectEditableUser(id);
        this.$http.put(this.getRoute('updateLinkToUser'),
          {
            id_myAbftUser: id,
            allowed_to_consult_member: item.allowed_to_consult_member,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            this.arrayEditsUser = _.reject(this.arrayEditsUser, function (item) {
              return item.id == id;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });

      },
      removeInscriptionUser: function (id) {
        this.isBusy = true
        let self = this;
        let item = _.find(this.getMember.my_a_b_f_t_user, function (item) {
          return item.id == id;
        });
        this.$http.post(this.getRoute('removeLinkToUser'),
          {
            id_myAbftUser: id,
          })
          .then(function (response) {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.success("Modification effectuée")
            self.getMember.my_a_b_f_t_user = response.body
            this.arrayEditsUser = _.reject(this.arrayEditsUser, function (item) {
              return item.id == id;
            });
          }, (response) => {
            this.isBusy = false
            this.disabledBtn = false
            self.$noty.error("Modification échouée")
          });
      }
    },
    filters: {
      idFormat: function (value) {
        return new Intl.NumberFormat("de-DE").format(value)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/MyABFTMembre.vue